import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from 'src/Components'
import { IconBell } from 'src/Components/shared/Icon'
import { RemoveAlertModal } from './RemoveAlertModal'

export const RemoveAlertButton = () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <Button
        onClick={() => setShowModal(true)}
        data-qa='confirm-listing-alert-button'
        aria-label='remove listing alert'
        iconStart={IconBell}
        compact
      >
        <FormattedMessage
          id='HomeSearch.listings.alerts.button_on'
          defaultMessage='Alerts on'
        />
      </Button>
      {showModal && <RemoveAlertModal hideAlert={() => setShowModal(false)} />}
    </>
  )
}
